/** How Database tabs open the shared run / batch / preview views and the console. */
export interface BatchRequest {
  migrationIds: number[];
  targets: string[];
  onlyPairs?: string[];
  title: string;
}

export interface RunnerNav {
  openRun: (rowId: number) => void;
  openBatch: (id: string) => void;
  openPreview: (scriptId: number) => void;
  openBatchDialog: (req: BatchRequest) => void;
  openConsole: (target: string, sql: string) => void;
}

/** Console hand-off (sessionStorage — SQL is too long for a URL). */
export const CONSOLE_PREFILL_KEY = 'cits.db.console.prefill';
